import { useEffect, useState } from 'react';
import { BREAKPOINTS } from '../constants';

export type Width = 'extraSmall' | 'small' | 'medium' | 'large' | 'extraLarge';

export type Height = 'short' | 'normal';

export const useViewportSize = (): {
  width?: Width;
  height?: Height;
} => {
  const [viewportSize, setViewportSize] = useState<{
    width?: Width;
    height?: Height;
  }>({});

  const getViewportSize = () => {
    let width: Width;
    let height: Height;

    if (window.innerWidth >= 0 && window.innerWidth < BREAKPOINTS.extraSmall) {
      width = 'extraSmall';
    } else if (
      window.innerWidth >= BREAKPOINTS.extraSmall &&
      window.innerWidth < BREAKPOINTS.small
    ) {
      width = 'small';
    } else if (
      window.innerWidth >= BREAKPOINTS.small &&
      window.innerWidth < BREAKPOINTS.large
    ) {
      width = 'medium';
    } else if (
      window.innerWidth >= BREAKPOINTS.large &&
      window.innerWidth < BREAKPOINTS.extraLarge
    ) {
      width = 'large';
    } else {
      width = 'extraLarge';
    }

    if (innerHeight < 600) {
      height = 'short';
    } else {
      height = 'normal';
    }

    setViewportSize((prevState) => {
      if (width !== prevState.width || height !== prevState.height)
        return { width, height };
      return prevState;
    });
  };

  useEffect(() => {
    getViewportSize();
    window.addEventListener('resize', getViewportSize);
    return () => {
      window.removeEventListener('resize', getViewportSize);
    };
  }, []);

  return viewportSize;
};
